import { ref, onMounted, onBeforeUnmount } from "vue";
import { useTranslationStore } from "@/stores/translations";
import { useRuntimeConfig, useFetch, useNuxtApp } from "#app";


export const useWhistleblowing = () => {
  const nuxtApp = useNuxtApp();

  const translationStore = useTranslationStore();
  const translate = translationStore.translate;

  const isLoading = ref(false);
  const LoadingTitle = ref("Loading...");
  const formSuccess = ref(false);
  const formTitle = ref(translate("whistleblowing.form"));
  const formMessage = ref(null);
  const showModal = ref(false);

  const privacyStatement = ref(false);
  const privacyStatement2 = ref(false);
  const fileName = ref(null);
  const isFileSelected = ref(false);
  const activeTab = ref('one');
  const isStep3Valid = ref(false);

  // ฟังก์ชันเมื่อกดปุ่ม Next
  const handleStep1Submit = () => {
    if (privacyStatement.value) {
        activeTab.value = 'two'
    }
  }

  const handleStep2Back = () => {
    if (privacyStatement.value) {
        activeTab.value = 'one'
    }
  }

  const handleStep3Back = () => {
    if (privacyStatement.value) {
        activeTab.value = 'two'
    }
  }

  const handleStep2Submit = (event) => {
    event.preventDefault(); // ป้องกันการ submit จริง
    
    const form = document.getElementById("formWhistleblowing");
    const requiredFields = form.querySelectorAll('.tab-pane#two input[required]');
    const emailField = form.querySelector('.tab-pane#two input[type="email"]'); // Find the email input field
  
    let isValid = true;
  
    requiredFields.forEach(input => {
      if (!input.value || input.value.trim() === '') {
        isValid = false;
        input.classList.add('is-invalid'); // ใช้ Bootstrap หรือใส่ class แสดง error ได้
      } else {
        input.classList.remove('is-invalid');
      }
    });
    

    // Validate email format
    const validateEmailField = () => {
      if (emailField && emailField.value !== '') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
        if (!emailRegex.test(emailField.value)) {
          emailField.classList.add('is-invalid'); // Add error class for invalid email
          console.error("Invalid email format:", emailField.value);
          return false;
        } else {
          emailField.classList.remove('is-invalid');
          return true;
        }
      }
      emailField.classList.remove('is-invalid');
      return true;
    };
    // Add onblur event to revalidate the email field
    if (emailField) {
        emailField.addEventListener('blur', validateEmailField);
    }

    // Perform initial email validation
    if (!validateEmailField()) {
      isValid = false;
    }
  
    if (!privacyStatement2.value) {
      isValid = false;
    }

    if (isValid) {
      activeTab.value = 'three';
      console.log('step 2 done')
    }
  }

  const validateStep3Fields = () => {
    const form = document.getElementById("formWhistleblowing");
    if (!form) return;
  
    const requiredFields = form.querySelectorAll('.tab-pane#three input[required], .tab-pane#three textarea[required]');
  
    let isValid = true;
  
    requiredFields.forEach((field) => {
      if (!field.value || field.value.trim() === '') {
        isValid = false;
      }
    });
  
    isStep3Valid.value = isValid;
  };

  const submitForm = async (event) => {
    
    try {

      const token = await nuxtApp.$recaptcha.execute("submit");
      const form = event.target;
      const formData = new FormData(form);

      formData.append("name", 'Whistleblowing');
      formData.append("template", 'whistleblowing');
      formData.append("g-recaptcha-response", token);

      const baseApi = useRuntimeConfig().public.baseApi;

      isLoading.value = true;
      LoadingTitle.value = "Sending ...";
      formSuccess.value = false;

      await useFetch(`${baseApi}/mail/whistleblowing`, {
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": "NUXT",
        },
        body: formData,
      }).then(
        (res) => {
          const data = res.data.value;

          if (data && data.status == "success") {
            formSuccess.value = true;
            formMessage.value = data.data;
            privacyStatement.value = false;
            privacyStatement2.value = false;
            form.reset();

            // clear file input label
            // Find the parent element with the class `custom-file-upload`
            const fileUploadElement = form.querySelector('.custom-file-upload');
            // Find the child element with the class `custom-file-label` and clear its text
            if (fileUploadElement) {
              const fileLabel = fileUploadElement.querySelector('.custom-file-label');
              if (fileLabel) {
                fileLabel.textContent = ''; // Clear the text
              }
            }

            // reset to step 1
            activeTab.value = 'one';
            
          } else {
            formSuccess.value = false;
            formMessage.value = data.data;
          }
        },
        (error) => {
          formSuccess.value = false;
          formMessage.value = "error usefetch:" + error;
        }
      );
    } catch (error) {
      formMessage.value = "error catch:" + error;
      formSuccess.value = false;
    }

    showModal.value = true;
    isLoading.value = false;
  };

  const resetModal = () => {
    showModal.value = false; // รีเซ็ตค่า showModal เมื่อ Modal ถูกปิด
  };

  onMounted(() => {
    const form = document.getElementById("formWhistleblowing");
    if (form) {
      form.addEventListener('input', validateStep3Fields);
    }
  
    translationStore.fetchTranslations();
    nuxtApp.$recaptcha.init();
    nuxtApp.$recaptcha.hideBadge = false;
  });

  onBeforeUnmount(() => {
  const form = document.getElementById("formWhistleblowing");
  if (form) {
    form.removeEventListener('input', validateStep3Fields);
  }
  nuxtApp.$recaptcha.destroy();
});

return {
    isLoading,
    LoadingTitle,
    formSuccess,
    formTitle,
    formMessage,
    showModal,
    handleStep1Submit,
    privacyStatement,
    privacyStatement2,
    activeTab,
    handleStep2Back,
    handleStep2Submit,
    handleStep3Back,
    validateStep3Fields,
    isStep3Valid,
    translate,
    submitForm,
    resetModal,
  };
};